import { connect } from 'react-redux'
import * as UserActions from '../stores/user/actions';
import TackResumeAllComponent from '../components/tack_resume_all';


const mapStateToProps = (state) => {
  return {
    user: state.default.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onResumeAllTacks: () => {
      dispatch(UserActions.resumeAll());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TackResumeAllComponent);



// WEBPACK FOOTER //
// ./src/containers/tack_resume_all.js